/**
 * Interface for the Cabinet result data generated by the Unity WebGL app.
 */

import IOrder from "./IOrder";

interface ICabinetResult {
    RootName: string;
    RootSize: {
        Width: number;
        Height: number;
        Depth: number;
    };
    Order: IOrder[];
}

export default ICabinetResult;
